<template>
  <span
    v-if="!$slots.default && newUiEnabled"
    v-b-tooltip="tooltipConfig"
    class="cursor-help ui-tooltip-icon"
    :title="value"
  >
    <UiIcon :fa="`fa ${iconClass}`" :size="16" />
  </span>
  <i
    v-else-if="!$slots.default"
    v-b-tooltip="tooltipConfig"
    :class="['fa cursor-help', iconClass]"
    :title="value"
  />
  <span v-else v-b-tooltip="tooltipConfig" class="cursor-help" :title="value">
    <slot />
  </span>
</template>

<script>
import { useNewUiEnabled } from "@/components/newUi/core/useNewUiEnabled";

export default {
  props: {
    value: {
      type: String,
      required: true,
    },

    iconClass: {
      type: String,
      default: "fa-info-circle",
    },

    bottom: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: null,
    },
  },

  setup() {
    return {
      newUiEnabled: useNewUiEnabled(),
    };
  },

  computed: {
    tooltipConfig() {
      return {
        hover: true,
        // if placement provided, use it, else fall back to previous behavior
        placement: this.placement ? this.placement : this.bottom ? "bottom" : "top",
        container: "body",
      };
    },
  },
};
</script>
